import React from 'react';
import * as PropTypes from 'prop-types';
import { Button, Modal, Image } from 'react-bootstrap';
import Intro from './Intro';
import { GAME_PAGE_INTRO, GAME_PAGE_PROGRESS } from '../../constants/game';
import LevelInfo from './LevelInfo';
import LevelSelector from './LevelSelector';
import logo from '../../img/logo_72.png';
import { CloseIcon } from '../Common/Icons';

import './PageViewer.sass';

const PageViewer = ({
  page,
  game,
  onHide,
  setGameView,
  //  toggleGameModal, // not used at the moment, could be used to add an X
  levelUp,
  gotoDesignChallenge,
  changeGameLevel,
  competition,
}) => (
  <Modal show={true} size="lg" onHide={onHide} role="dialog" aria-modal="true" aria-labelledby="wb-nationals-title">
    <Modal.Header className="flex-column p-0 pt-2">
      <Image
        src={competition ? competition.logo_image : logo}
        alt="WhiteBox Learning"
        style={{ width: '55px' }}
      />
      <h3 className="text-uppercase" id="wb-nationals-title">
        <span className="wb-title">
          {competition ? competition.name : 'WhiteBox Nationals'}&nbsp;
        </span>
        -&nbsp;
        <span className="text-muted">Level {game.level.level}</span>
      </h3>
      <Button
        className="position-absolute top-0 end-0 fs-4"
        variant="link"
        onClick={onHide}
        aria-label="Close dialog"
      >
        <CloseIcon />
      </Button>
    </Modal.Header>

    <Modal.Body className="mb-2">
      {page === GAME_PAGE_INTRO ? (
        <Intro
          getStarted={() => setGameView(GAME_PAGE_PROGRESS)}
          compName={competition ? competition.name : 'WhiteBox Nationals'}
        />
      ) : (
        <>
          {game.canChangeLevels ? (
            <LevelSelector
              game={game}
              changeGameLevel={changeGameLevel}
              competition={competition}
            />
          ) : (
            <LevelInfo
              game={game}
              level={game.level}
              levelUp={levelUp}
              setGameView={setGameView}
              gotoDesignChallenge={gotoDesignChallenge}
              compName={competition ? competition.name : 'WhiteBox Nationals'}
            />
          )}
        </>
      )}
    </Modal.Body>
  </Modal>
);

PageViewer.propTypes = {
  page: PropTypes.string,
  game: PropTypes.object,
  onHide: PropTypes.func.isRequired,
  setGameView: PropTypes.func.isRequired,
  toggleGameModal: PropTypes.func.isRequired,
  levelUp: PropTypes.func.isRequired,
  gotoDesignChallenge: PropTypes.func.isRequired,
  changeGameLevel: PropTypes.func.isRequired,
};
PageViewer.defaultProps = {
  page: GAME_PAGE_INTRO,
};

export default PageViewer;
